/** Mount companion panes only when there is room; phones never load them. */
import { useEffect, useState } from "react";

export const WIDE_QUERY = "(min-width: 900px)";
export function useWide(): boolean {
  const [wide, setWide] = useState(() => typeof window.matchMedia === "function" && window.matchMedia(WIDE_QUERY).matches);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const media = window.matchMedia(WIDE_QUERY);
    const update = (): void => setWide(media.matches);
    media.addEventListener("change", update);
    update();
    return () => media.removeEventListener("change", update);
  }, []);
  return wide;
}
